import * as React from 'react';
import * as _ from 'lodash';
import Tabs from '../giContent_tabs';
export default function () {
    return React.createElement('div', { 'className': 'full-height w-100' }, React.createElement('h2', { 'className': 'page-title' }, 'Content'), React.createElement('div', { 'className': 'tabs-container' }, React.createElement(Tabs, { 'props': this.props })));
}